<template>
  <div class="mb30">
    <discount-rate-card :type="type" :cuDiscountRate="cuDiscountRate" :levelBankList="levelBankList" :logo="logo" v-if="levelBankList"></discount-rate-card>
  </div>
</template>

<script>
import DiscountRateCard from './DiscountRateCard.vue';
export default {
  components: { DiscountRateCard },
  props: ['rate', 'logo', 'type'],
  data () {
    return {
      cuDiscountRate: [],
      levelBankList: null,
    }
  },
  created () {
    this.initData()
  },
  methods: {
    // 初始化数据
    initData () {
      if (this.rate && this.rate.fuMinRateDtoList) {
        // 对数据进行排序
        this.rate.fuMinRateDtoList.sort((a, b) => {
          let tem1 = JSON.stringify(this.$store.state.publicData.acceptBankLevelType);
          //  承兑行等级
          if (a.bankLevel == b.bankLevel) {
            //  剩余期限范围
            if (a.dueDate == b.dueDate) {
              //  金额范围
              return b.ebillAmt.match(/\d+/g)[0] - a.ebillAmt.match(/\d+/g)[0];
            } else if (new Date(a.dueDate.split('≤到期日≤')[0]) > new Date(b.dueDate.split('≤到期日≤')[0])) {
              return 1; // 交换位置
            } else if (new Date(a.dueDate.split('≤到期日≤')[0]) < new Date(b.dueDate.split('≤到期日≤')[0])) {
              return -1;
            }
            // return 0;
          } else if (a.bankLevel > b.bankLevel) {
            return 1; // 交换位置
          } else if (a.bankLevel < b.bankLevel) {
            return -1; // 不交换位置
          }
        });

        // 当前承兑行等级的列表对应的数组第几个
        let acceptBankLevelTypeList = {};

        // 当前票据类型对应数组第几个
        let draftTypeList = {};

        console.log(this.rate.fuMinRateDtoList)
        for (let i = 0; i < this.rate.fuMinRateDtoList.length - 1; i++) {
          if (i == 0) {
            this.cuDiscountRate.push(this.rate.fuMinRateDtoList[i]);
            this.cuDiscountRate[this.cuDiscountRate.length - 1].arrayList = [];
            this.cuDiscountRate[this.cuDiscountRate.length - 1].arrayList.push(this.rate.fuMinRateDtoList[i]);

            // 承兑行等级
            this.cuDiscountRate[this.cuDiscountRate.length - 1].acceptBankLevelTypeTotal = 1; // 承兑行等级的总数
            acceptBankLevelTypeList[this.rate.fuMinRateDtoList[i].bankLevel] = this.cuDiscountRate.length - 1; // 将数组的下标存入数据
            // console.log(this.cuDiscountRate[this.cuDiscountRate.length-1].arrayList, "console.log(this.cuDiscountRate[this.cuDiscountRate.length-1].arrayList)")

          }
          // 比较第一个和后一个数据
          if (this.rate.fuMinRateDtoList[i].bankLevel == this.rate.fuMinRateDtoList[i + 1].bankLevel && this.rate.fuMinRateDtoList[i].dueDate == this.rate.fuMinRateDtoList[i + 1].dueDate) {
            // console.log(this.cuDiscountRate[this.cuDiscountRate.length-1].arrayList)
            this.cuDiscountRate[this.cuDiscountRate.length - 1].arrayList.push(this.rate.fuMinRateDtoList[i + 1]);
          } else {
            // 加入新数组
            this.cuDiscountRate.push(this.rate.fuMinRateDtoList[i + 1]);
            this.cuDiscountRate[this.cuDiscountRate.length - 1].arrayList = [];
            this.cuDiscountRate[this.cuDiscountRate.length - 1].arrayList.push(this.rate.fuMinRateDtoList[i + 1]);

            // 承兑行等级
            if (this.rate.fuMinRateDtoList[i + 1].bankLevel == this.cuDiscountRate[this.cuDiscountRate.length - 2].bankLevel) {
              // 承兑行等级进行比较
              // console.log(acceptBankLevelTypeList[this.rate.fuMinRateDtoList[i+1].bankLevel], "acceptBankLevelTypeList[this.rate.fuMinRateDtoList[i+1].bankLevel")
              this.cuDiscountRate[acceptBankLevelTypeList[this.rate.fuMinRateDtoList[i + 1].bankLevel]].acceptBankLevelTypeTotal++;
            } else {
              // 将数组的下标存入数据
              acceptBankLevelTypeList[this.rate.fuMinRateDtoList[i + 1].bankLevel] = this.cuDiscountRate.length - 1; // 将数组的下标存入数据
              this.cuDiscountRate[this.cuDiscountRate.length - 1].acceptBankLevelTypeTotal = 1;
            }


          }

        }

        this.levelBankList = {};
        for (let i = 0; i < this.rate.fuMinAcceptorDtoList.length; i++) {
          if (!this.levelBankList[this.rate.fuMinAcceptorDtoList[i].actLevel]) {
            this.levelBankList[this.rate.fuMinAcceptorDtoList[i].actLevel] = [this.rate.fuMinAcceptorDtoList[i].actM];
          } else {
            this.levelBankList[this.rate.fuMinAcceptorDtoList[i].actLevel].push(this.rate.fuMinAcceptorDtoList[i].actM)
          }
        }
      }

    },
    // 票面范围处理
    getScope (start, end, index) {
      if (index == 0) {
        return "[" + start.div(10000).toFixed(0) + "," + end.div(10000).toFixed(0) + "]";
      } else {
        return "[" + start.div(10000).toFixed(0) + "," + end.div(10000).toFixed(0) + ")";
      }
    },
  },
  watch: {
    rate: {
      handler () {
        console.log('==============')
        this.initData()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/common/DiscountRateCardFm.vue